import { createBrowserHistory } from 'history'

export const appHistory = createBrowserHistory()
export const appUrl = window.location.origin
